import React from 'react';
import Navbar from '../../components/navbar';
import FormularioEditarSucursal from '../../components2/formularioEditarSucursal';

function EditarSucursal() {
    return (
        <FormularioEditarSucursal />
    )
}

export default EditarSucursal;